<template>
  <div class="app-container">
    <app-search>
      <div slot="content">
        <el-form inline :model="listQuery" label-suffix="：" :label-width="$t('system.department.departmentLabelWidth')">
          <el-form-item :label="$t('system.department.name')" :label-width="$t('system.department.departmentLabelWidth')">
            <el-input v-model="listQuery.departmentName" :placeholder="$t('system.department.name')" clearable />
          </el-form-item>
        </el-form>
      </div>
      <!-- 清空查询按钮 -->
      <app-search-button
        slot="bottom"
        :is-collapse="false"
        @click-filter="handleFilter"
        @click-clear="handleClear"
      />
    </app-search>
    <!-- 授权按钮 -->
    <app-authorize-button
      :data="authouizeList"
      @click-add="handleAdd"
      @click-update="handleUpdate"
      @click-delete="handleDelete"
      @click-obd="handleObd"
      @click-export="hanleExport"
      @click-reset-pwd="handleResetPwd"
      @click-filter="showfilter=true"
    >
      <checked-Filter
        slot="check-filter"
        :show.sync="showfilter"
        :list="tableList"
      />
    </app-authorize-button>
    <!-- table -->
    <el-table
      ref="table"
      v-loading="listLoading"
      size="mini"
      :data="list"
      :max-height="tableHeight"
      :header-row-style="headerRowStyle"
      :row-style="rowStyle"
      :header-cell-style="headerCellStyle"
      border
      fit
      highlight-current-row
      style="width: 100%"
      @current-change="handleCurrentRowChange"
      @sort-change="sortChange"
    >
      <el-table-column :label="$t('table.id')" align="center" width="65">
        <template slot-scope="scope">
          <span>{{ (scope.$index+1)+(listQuery.pageNum -1)*listQuery.pageSize }}</span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="(item,index) in filterTableList"
        :key="index"
        :label="item.value"
        :prop="item.prop"
        :align="item.position"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <el-button
            v-if="item.prop=='total'"
            @click.native.prevent="viewObd(scope.row)"
            type="text"
            size="small">
            {{ scope.row[item.prop] }}
          </el-button>
          <!-- 如果需要特性化显示可使用v-if，v-else-if，v-else-->
          <span v-else>{{ scope.row[item.prop] }}</span>
        </template>
      </el-table-column>
    </el-table>
    <!-- 分页 -->
    <div :class="[total > 0 ? 'visible':'hidden', 'pagination-container']">
      <el-pagination
        :current-page="listQuery.pageNum"
        :page-sizes="[10,20,30,50]"
        :page-size="listQuery.pageSize"
        :total="total"
        background
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <!-- 新增修改dialog -->
    <add-update-dialog
      :visibles.sync="addUpdateVisible"
      :is-edit="isEdit"
      :data="isEdit ? currentRow : {}"
      @add-complete="addComplete"
      @update-complete="updateComplete"
    />
    <!-- OBD授权 -->
    <obd 
      :visible.sync="obdVisible"
      :view="obdView"
      :id="obdVisible ? currentRow.departmentId : ''"
      />
  </div>
</template>
<script>
// 混入
import { pagingMixin } from '@/mixins/table'
import { otherHeight } from '@/mixins/getOtherHeight'
import { tableStyle } from '@/mixins/tableStyle'
import { getPageButton } from '@/mixins/getButton'
// request
import { listUrl, deleteUrl, exportUrl, resetPwdUrl } from '@/api/system/department'
import resolve from '@/api/resolve'
// 组件
import AddUpdateDialog from './components/addUpdateDialog'
import Obd from './components/obd'
export default {
  name: 'department',
  components: {
    AddUpdateDialog,
    Obd
  },
  mixins: [pagingMixin, otherHeight, tableStyle, getPageButton],
  computed: {
    filterTableList() {
      return this.tableList.filter(item => item.checked)
    }
  },
  data() {
    return {
      listQuery: {},
      showfilter: false,
      tableList: [
        { value: this.$t('system.department.name'), prop: 'departmentName', position: 'center', checked: true, sortable: true },
        { value: this.$t('system.company.adminAccount'), prop: 'loginName', position: 'center', checked: true, sortable: true },
        { value: this.$t('system.company.adminRealName'), prop: 'realName', position: 'center', checked: true, sortable: true },
        { value: this.$t('public.mobile'), prop: 'mobile', position: 'center', checked: true, sortable: true },
        { value: this.$t('system.company.obdCount'), prop: 'total', position: 'center', checked: true },
        { value: this.$t('public.createTime'), prop: 'createdOn', position: 'center', checked: true, sortable: true },
        { value: this.$t('public.note'), prop: 'remark', position: 'center', checked: true }
      ],
      authouizeList: [],     
      tableHeight: 0,
      total: 0,
      list: [],
      listLoading: false,
      addUpdateVisible: false, // 新增修改dialog
      isEdit: false, // false: 新增, true:编辑
      obdVisible: false,
      obdView: false,
      currentRow: null
    }
  },
  methods: {
    listLoad() {
      this.listLoading = true
      this.$http.post(listUrl, this.listQuery).then(({ data }) => {
        if (data.code === 0) {
          this.list = data.data
          this.total = data.total
          let orderSort = 'roleName,isSys,dataScope'
          this.setOrderField(orderSort, this.tableList)
        }
      }).finally(()=>{
        this.listLoading = false
      })
    },
    /**
     * 检测是否未选择
     */
    checkCurrentRowEmpty () {
      return !this.currentRow
    },
    handleCurrentRowChange (val) {
      this.currentRow = val
    },
    // 新增
    handleAdd() {
      this.isEdit = false    
      this.addUpdateVisible = true
    },
    // 新增完成
    addComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.createSuccess'),
        duration: 2 * 1000
      })
    },
    // 编辑
    handleUpdate() {        
      if (!this.checkCurrentRowEmpty()) {          
        this.isEdit = true
        this.isPermiss=false
        this.addUpdateVisible = true
      } else {
        this.$alert( this.$t('public.updateTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
          .then(() => {})
          .catch(() => {})
      }
    },
    handleObd() {
      if (!this.checkCurrentRowEmpty()) {
        this.obdView = false
        this.obdVisible = true
      } else {
        this.$alert( this.$t('public.operationTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
      }
    },
    viewObd(row) {
      this.currentRow = row
      this.obdView = true
      this.obdVisible = true
    },
    // 编辑成功
    updateComplete() {
      this.listLoad()
      this.$message.success({
        message: this.$t('public.updateSuccess'),
        duration: 2 * 1000
      })
    },
    // 删除
    handleDelete() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t('public.deleteTips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      const deleteData = {
        departmentId: this.currentRow.departmentId,
        userId: this.currentRow.userId
      }
      this.$confirm(this.$t('public.deleteItemTips'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
      .then(() => {
        this.$http.delete(deleteUrl, { data: deleteData }).then(({ data }) => {
          if (data.code === 0) {
            this.listLoad()
            this.$message.success({
              message: this.$t('public.deleteSuccess'),
              duration: 2 * 1000
            })
          }
        })
      })
    },
    // 导出
    hanleExport() {
      this.$http.post(exportUrl, this.listQuery, {
        responseType: 'arraybuffer'
      })
    },
    handleResetPwd() {
      if (this.checkCurrentRowEmpty()) {
        this.$alert(this.$t('system.user.tips'), this.$t('public.tips'), {
          confirmButtonText: this.$t('public.define')
        })
        return
      }
      this.$confirm(this.$t('system.user.msg1'), this.$t('public.tips'), {
        confirmButtonText: this.$t('public.define'),
        cancelButtonText: this.$t('public.cancel'),
        type: 'warning'
      })
      .then(() => {
        this.$http.patch(resolve(resetPwdUrl, this.currentRow.userId)).then(({ data }) => {
          if (data.code === 0) {
            this.listLoad()
            this.$message.success({
              message: this.$t('system.user.msg2'),
              duration: 2 * 1000
            })
          }
        })
      })
    }
  }
}
</script>
